import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.031 13.58c-.482 0-.848-.13-1.098-.393-.25-.258-.374-.647-.374-1.168v-4.5c0-.517.124-.904.374-1.162.25-.258.616-.387 1.098-.387h5.942c.482 0 .848.129 1.098.387.25.258.374.645.374 1.162v4.5c0 .52-.125.91-.374 1.168-.25.262-.616.394-1.098.394H4.03Zm-.31-7.077V4.484c0-.783.152-1.436.456-1.961A3.068 3.068 0 0 1 5.39 1.33c.499-.267 1.036-.4 1.612-.4.575 0 1.113.133 1.612.4.5.266.902.664 1.206 1.193.31.525.464 1.178.464 1.961v2.019H9.097v-2.14c0-.494-.098-.911-.292-1.25a1.962 1.962 0 0 0-.762-.78 2.095 2.095 0 0 0-1.041-.267c-.377 0-.724.089-1.041.267a1.962 1.962 0 0 0-.762.78c-.19.339-.285.756-.285 1.25v2.14H3.72Z" }, null, -1)
  ]))]))
}
export default { render: render }